import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const actions = {}
const state = {
  navs: [],
  offsideInfo:{},
  footInfo:{},
  footList:[],
  signFlag:false,
  userRealName:'',
  userInfo:'',
  userHeadImg:'',
  outSign:false,//是否重新登录

  noPermission:false, //没有权限弹窗
  needMsg:{},//需要等级信息
  followFlag:false,//关注取关
  memberFollowFlag:false,//关注人，取关人
}
const mutations = {
  //导航条
  setNav(state, msg) {
    state.navs = msg
  },
  //侧边栏信息
  setOffsideInfo(state, msg) {
    state.offsideInfo = msg
  },
  //页面底部信息
  setFootInfo(state, msg) {
    state.footInfo = msg
  },
  //底部列表
  setFootList(state, msg) {
    state.footList = msg
  },
  //登录状态
  setSignFlag(state, msg) {
    state.signFlag = msg
  },
  //用户真实姓名
  setUserRealName(state, msg) {
    state.userRealName = msg
  },
  //用户信息
  setUserInfo(state, msg) {
    state.userInfo = msg
  },
  
  //用户头像
  setuserHeadImg(state, msg) {
    state.userHeadImg = msg
  },
  //
  setoutSign(state, msg) {
    state.outSign = msg
  },
  setNoPermission(state, msg) {
    // console.log('xiugai');
    state.noPermission = msg
  },
  setNeedMsg(state, msg) {
    // console.log('xiugai');
    state.needMsg = msg
  },
  setFollowFlag(state, msg) {
    state.followFlag = msg
  },
  
  setMemberFollowFlag(state, msg) {
    state.memberFollowFlag = msg
  },
}
export default new Vuex.Store({
  state,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js